module.exports = __webpack_public_path__ + "img/lesotho.14d4cbfa.svg";